import createIcon from '../../createIcon';

/**
 * @component @name ChairAlt
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTcgMTBDMTguMSAxMCAxOSA5LjEgMTkgOFY1QzE5IDMuOSAxOC4xIDMgMTcgM0g3QzUuOSAzIDUgMy45IDUgNVY4QzUgOS4xIDUuOSAxMCA3IDEwSDhWMTJIN0M1LjkgMTIgNSAxMi45IDUgMTRWMjFIN1YxOEgxN1YyMUgxOVYxNEMxOSAxMi45IDE4LjEgMTIgMTcgMTJIMTZWMTBIMTdaTTcgOFY1SDE3VjhIN1pNMTcgMTZIN1YxNEgxN1YxNlpNMTQgMTJIMTBWMTBIMTRWMTJaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ChairAlt = createIcon('ChairAlt', [
  [
    'path',
    {
      d: 'M17 10C18.1 10 19 9.1 19 8V5C19 3.9 18.1 3 17 3H7C5.9 3 5 3.9 5 5V8C5 9.1 5.9 10 7 10H8V12H7C5.9 12 5 12.9 5 14V21H7V18H17V21H19V14C19 12.9 18.1 12 17 12H16V10H17ZM7 8V5H17V8H7ZM17 16H7V14H17V16ZM14 12H10V10H14V12Z',
      key: 'ihglym',
    },
  ],
]);

export default ChairAlt;
